import icAddSquare from 'assets/images/ic-add-square.svg'
import { Button, InlineError, Input, Spinner, Switch } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import TabToggleList from 'components/commons/tab-toogle-list'
import UploadImage from 'components/commons/upload-image'

export const CategoryWinner = ({
    data,
    items,
    setItems,
    setSubItems,
    onChangeForm,
    onChangeItem,
    onChangeSubItem,
    onAddNewItem,
    addSubItem,
    errorForm,
    isLoadingUpload,
    isLoading,
    isUpdating,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-6 pb-[280px] overflow-auto'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex items-center justify-between border border-neutral-20 px-6 py-4 rounded-lg'}>
                        <p className={'font-semibold text-lg text-black-95'}>{'Category Winner'}</p>
                        <div className={'flex items-center space-x-6'}>
                            <p className={'font-semibold'}>{data?.is_show ? 'Show' : 'Hide'}</p>
                            <Switch
                                name={'is_show'}
                                checked={data?.is_show}
                                onChange={(e) => onChangeForm({ ...e, value: e.checked })}
                            />
                        </div>
                    </div>
                    <TabToggle
                        title={'Category Winner'}
                        content={
                            <div
                                className={`flex-1 flex-col ${(data?.title_image_url?.base64 || data?.title_image_url) && 'space-y-3'}`}
                            >
                                <div className={'font-semibold text-blue-90 required'}>Image Title</div>
                                <UploadImage
                                    className={'w-fit'}
                                    classNameImage={'!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'}
                                    id={'image-title'}
                                    value={data?.title_image_url?.base64 || data?.title_image_url}
                                    onChange={(value) => onChangeForm({ name: 'title_image_url', value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.title_image_url} />
                            </div>
                        }
                    />
                    <div className={'flex flex-col space-y-6'}>
                        {items?.map((item, parentIndex) => (
                            <TabToggleList
                                key={`category-${parentIndex}`}
                                index={parentIndex}
                                title={`Category-${parentIndex + 1}`}
                                content={
                                    <div className={'flex flex-col space-y-16'}>
                                        <div className={'flex space-x-16'}>
                                            <div
                                                className={`flex-1 flex-col ${(item?.image_url?.base64 || item?.image_url) && 'space-y-3'}`}
                                            >
                                                <div className={'font-semibold text-blue-90 required'}>
                                                    Category Icon
                                                </div>
                                                <UploadImage
                                                    className={'w-fit'}
                                                    classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                                    id={`parent-category-icon-${parentIndex}`}
                                                    value={item?.image_url?.base64 || item?.image_url}
                                                    onChange={(value) =>
                                                        onChangeItem({
                                                            name: 'image_url',
                                                            value,
                                                            parentIndex,
                                                        })
                                                    }
                                                />
                                                <InlineError
                                                    className='mt-2'
                                                    message={errorForm?.categories?.[parentIndex]?.image_url}
                                                />
                                            </div>
                                            <div className={'flex-1 flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90 required'}>Title</div>
                                                <Input
                                                    className={'flex-1'}
                                                    name={'title'}
                                                    placeholder={'Masukkan title'}
                                                    value={item?.title}
                                                    onChange={(item) => onChangeItem({ ...item, parentIndex })}
                                                />
                                                <InlineError
                                                    className='mt-2'
                                                    message={errorForm?.categories?.[parentIndex]?.title}
                                                />
                                            </div>
                                        </div>
                                        <div className={'flex flex-col space-y-6'}>
                                            {item.subcategories?.map((subItem, index) => (
                                                <TabToggleList
                                                    key={`category-${index}`}
                                                    index={index}
                                                    title={`Category-Winner-${index + 1}`}
                                                    content={
                                                        <div className={'flex space-x-16'}>
                                                            <div
                                                                className={`flex-1 flex-col ${(subItem?.image_url?.base64 || subItem?.image_url) && 'space-y-3'}`}
                                                            >
                                                                <div className={'font-semibold text-blue-90 required'}>
                                                                    Category Icon
                                                                </div>
                                                                <UploadImage
                                                                    className={'w-fit'}
                                                                    classNameImage={
                                                                        '!w-48 !h-48 border border-neutral-30 rounded-md'
                                                                    }
                                                                    id={`category-icon-${parentIndex}-${index}`}
                                                                    value={
                                                                        subItem?.image_url?.base64 || subItem?.image_url
                                                                    }
                                                                    onChange={(value) =>
                                                                        onChangeSubItem({
                                                                            name: 'image_url',
                                                                            value,
                                                                            parentIndex,
                                                                            index,
                                                                        })
                                                                    }
                                                                />
                                                                <InlineError
                                                                    className='mt-2'
                                                                    message={
                                                                        errorForm?.categories?.[parentIndex]
                                                                            ?.subcategories?.[index]?.image_url
                                                                    }
                                                                />
                                                            </div>
                                                            <div className={'flex-1 flex-col space-y-3'}>
                                                                <div className={'font-semibold text-blue-90 required'}>
                                                                    Title
                                                                </div>
                                                                <Input
                                                                    className={'flex-1'}
                                                                    name={'title'}
                                                                    placeholder={'Masukkan title'}
                                                                    value={subItem?.title}
                                                                    onChange={(item) =>
                                                                        onChangeSubItem({
                                                                            ...item,
                                                                            parentIndex,
                                                                            index,
                                                                        })
                                                                    }
                                                                />
                                                                <InlineError
                                                                    className='mt-2'
                                                                    message={
                                                                        errorForm?.categories?.[parentIndex]
                                                                            ?.subcategories?.[index]?.title
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    }
                                                    items={item.subcategories}
                                                    setItems={(item) => setSubItems(item, parentIndex)}
                                                />
                                            ))}
                                            <InlineError className='mt-2' message={errorForm?.category} />
                                            <Button
                                                className={'w-fit'}
                                                type={'outline'}
                                                icon={icAddSquare}
                                                title={'Add New Winner'}
                                                onClick={() => addSubItem(parentIndex)}
                                            />
                                        </div>
                                    </div>
                                }
                                items={items}
                                setItems={setItems}
                                isDisableDelete={items?.length === 1}
                            />
                        ))}
                        <InlineError className='mt-2' message={errorForm?.category} />
                        <Button
                            className={'w-fit'}
                            type={'outline'}
                            icon={icAddSquare}
                            title={'Add New Item'}
                            onClick={onAddNewItem}
                        />
                    </div>
                    <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                        <Button
                            className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                            loading={isLoadingUpload || isUpdating}
                            title={'SAVE ALL CHANGES'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
